import { useState } from "react";
import { toast } from "sonner";
import { HeartPulse, Loader2 } from "lucide-react";
import { checkVoicesNow } from "@/lib/sunoVoicesApi";
import { fmtAgo } from "@/lib/studioApi";
import { safeApiError } from "@/lib/safeErrorText";

/** "Voice check: OK · 2 h ago" + Check now — the same free check the 6 AM daily run does. */
export default function VoiceHealthLine({ voice, onChanged }) {
  const [busy, setBusy] = useState(false);
  const h = voice.health;
  const text = !h ? "Checked every morning at 6 AM" : h.ok === false ? "Needs re-making" : h.ok ? `OK · checked ${fmtAgo(h.checked_at)}` : `Couldn't check ${fmtAgo(h.checked_at)} — will try again`;
  const check = async () => {
    setBusy(true);
    try {
      const next = (await checkVoicesNow()).find((v) => v.id === voice.id);
      if (next) onChanged(next);
      if (next?.status === "broken") toast.error("This voice needs re-making");
      else if (next?.health?.ok) toast.success("Your voice is working");
      else toast("Couldn't reach the music engine — try again later");
    } catch (e) { toast.error("Couldn't check the voice", { description: safeApiError(e) }); }
    finally { setBusy(false); }
  };
  return (
    <p data-testid="voice-health-line" className="mt-3 flex flex-wrap items-center gap-2 text-[12px] text-white/55">
      <HeartPulse className="h-3.5 w-3.5 text-emerald-300" /> Voice check: <span data-testid="voice-health-status" className="text-white/80">{text}</span>
      <button type="button" data-testid="voice-health-check" onClick={check} disabled={busy} className="inline-flex items-center gap-1 rounded-full border border-white/15 px-2.5 py-0.5 font-mono text-[10px] uppercase tracking-wider text-white/70 transition-colors hover:bg-white/[0.08] disabled:opacity-40">
        {busy ? <Loader2 className="h-3 w-3 animate-spin" /> : null} Check now
      </button>
    </p>
  );
}
